import { IdentityStatus } from '../enums/identity-status.enum';

export const IDENTITY_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.identity.v1+json';

export class Identity {
  public id: string;
  public status: IdentityStatus;
  public emails: string[];
  public phones: string[];

  constructor(backendIdentity?: BackendIdentity) {
    if (backendIdentity) {
      this.id = backendIdentity.id;
      this.status = backendIdentity.status;
      this.emails = this.sortMasked(backendIdentity.emails);
      this.phones = this.sortMasked(backendIdentity.phones);
    }
  }

  private sortMasked(identifiers: string[]): string[] {
    if (!identifiers) {
      return identifiers;
    }

    const isMasked = (identifier: string) => identifier.includes("*");
    return identifiers.sort((a, b) => {
      if ((isMasked(a) && isMasked(b)) || (!isMasked(a) && !isMasked(b))) {
        return a.localeCompare(b);
      } else if (isMasked(b)) {
        // unmasked first
        return -1;
      } else {
        return 1;
      }
    });
  }
}

export interface BackendIdentity {
  id?: string;
  status: IdentityStatus;
  emails?: string[];
  phones?: string[];
}
